"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidUserOwnership = exports.getUserOwnership = exports.getUserOwnershipFromUser = void 0;
const root_1 = require("../../root");
const getUserOwnershipFromUser = (user) => {
    var _a;
    const pricePlan = (_a = user.company) === null || _a === void 0 ? void 0 : _a.pricePlan;
    if (!pricePlan)
        throw new Error("Unable to find company pricePlan.");
    const userOwnershipTypes = [
        { ownershipType: root_1.UserOwnership.Byggfakta, roles: root_1.BYGGFAKTA_ROLES },
        { ownershipType: root_1.UserOwnership.Tendium, roles: root_1.TENDIUM_ROLES },
        { ownershipType: root_1.UserOwnership.Clira, roles: root_1.CLIRA_ROLES },
    ];
    const ownership = userOwnershipTypes.filter(({ roles }) => {
        return roles.some((role) => role.toString() === pricePlan.toString());
    });
    // we don't expect no or multiple ownerships per company/user
    if (ownership.length === 0 || ownership.length > 1) {
        throw Error("Unable to determine user ownership.");
    }
    return ownership[0].ownershipType;
};
exports.getUserOwnershipFromUser = getUserOwnershipFromUser;
const getUserOwnership = (context) => {
    var _a, _b;
    if (!((_b = (_a = context.user) === null || _a === void 0 ? void 0 : _a.company) === null || _b === void 0 ? void 0 : _b.pricePlan))
        throw Error("Unable to find company pricePlan.");
    return (0, exports.getUserOwnershipFromUser)(context.user);
};
exports.getUserOwnership = getUserOwnership;
const isValidUserOwnership = (ownership) => {
    return root_1.USER_OWNERSHIPS.includes(ownership);
};
exports.isValidUserOwnership = isValidUserOwnership;
